import { useTranslation } from 'react-i18next';

import BaseModal from '../BaseModal/BaseModal.component';

const ConfirmModal = ({ action }) => {
	const { t } = useTranslation();

	return (
		<BaseModal id="confirm-modal" buttonText={t('confirm')} buttonAction={action}>
			<div className="container-fluid">{t('are_you_sure_to_do_this')}</div>
		</BaseModal>
	);
};

export default ConfirmModal;